import { useMapStoreStateToClientState } from './useMapStoreStateToClientState';
import type { Store } from '@/stores';

export default function useStateOfAuth(store: Store) {
  return useMapStoreStateToClientState(store, (store) => ({
    user: store.appStore.user?.user,
    isUser: store.appStore.user?.isUser,
    userId: store.appStore.user?.user?.id,
    isLoggedIn: store.myAccountStore?.loginPage?.loginStore?.isLoggedIn,
    currentCurrency: store.appStore.currency?.currentCurrency,
    hasVerifiedPhone: store.appStore.user?.user?.hasVerifiedPhone,
    hasVerifiedEmail: store.appStore.user?.user?.hasVerifiedEmail,
  }));
}
